import {_, __, _id} from "../util/dom";
import HtmlTemplate from "../templating/HtmlTemplate";
import {navigateToQuestion} from "../nav/carouselPaging";
import {
    allQuestions,
    questionAssessorRating,
    questionCustomerRating,
    questionCustomerResponseIsFilled,
    questionSequenceId,
    questionTextAreasAreFilled,
    unfilledQuestions
} from "./questions";

export default class ReportTodoList {

    constructor() {
        this.modal = $(_id("todo-list-modal"));
        this.todoListHtml = _(".todo-list", this.modal[0]);
        this.itemTemplate = new HtmlTemplate(_id("todo-list-template"));

        this.addEventListeners();
    }

    addEventListeners() {
        $('.todo-list-button').click(this.openTodoModal.bind(this));
    }

    addTodoNavigationEventListener() {
        $(__("tr", this.todoListHtml)).click(this.navigateToElement.bind(this));
    }

    openTodoModal() {
        this.updateTodoListHtml();
        this.modal.modal('open');
    }

    closeTodoModal() {
        this.modal.modal('close');
    }

    statusToIcon(isPositive) {
        if(isPositive) {
            return "<i class='material-icons green-text'>check</i>"
        }
        return "<i class='material-icons red-text'>close</i>"
    }

    htmlElementHtml(element) {
        if(element) {
            let thisElement = element.cloneNode(true);
            thisElement.style.margin = "auto";
            return thisElement.outerHTML;
        }
        return null;
    }

    updateTodoListHtml() {
        const questions = allQuestions();

        const questionToItemInfo = question => [
            question.id.substring(question.id.indexOf('-') + 1),
            questionSequenceId(question),
            this.statusToIcon(questionCustomerResponseIsFilled(question)),
            this.htmlElementHtml(questionCustomerRating(question)),
            this.statusToIcon(questionTextAreasAreFilled(question)),
            this.htmlElementHtml(questionAssessorRating(question)),
        ];
        const fillInfo = questions.map(questionToItemInfo);

        this.todoListHtml.innerHTML = this.itemTemplate.fillMulti(fillInfo);
        this.addTodoNavigationEventListener();
    }

    navigateToElement(evt) {
        const row = evt.currentTarget;
        const questionId = row.dataset.question;

        navigateToQuestion(questionId);
        this.closeTodoModal();
    }

}